//银行字典

export const bankCode = {
  // 通用
  ty:{
    '002':require('./img/002ty@4x.png'),
    '003':require('./img/003ty@4x.png'),
    '004':require('./img/004ty@4x.png'),
    '005':require('./img/005ty@4x.png'),
    '006':require('./img/006ty@4x.png'),
    '007':require('./img/007ty@4x.png'),
    '009':require('./img/009ty@4x.png'),
    '011':require('./img/011ty@4x.png'),
    '012':require('./img/012ty@4x.png'),
    '014':require('./img/014ty@4x.png'),
    '015':require('./img/015ty@4x.png'),
    '016':require('./img/016ty@4x.png'),
    '017':require('./img/017ty@4x.png'),
    '018':require('./img/018ty@4x.png'),
    '021':require('./img/021ty@4x.png'),
    '022':require('./img/022ty@4x.png'),
    '903':require('./img/903ty@4x.png'),
    '904':require('./img/904ty@4x.png'),
    '907':require('./img/907ty@4x.png'),
    '915':require('./img/915ty@4x.png'),
  },
  // 银行卡管理
  yhkgl:{
    '002':require('./img/002yhkgl.jpg'),
    '003':require('./img/003yhkgl.jpg'),
    '004':require('./img/004yhkgl.jpg'),
    '005':require('./img/005yhkgl.jpg'),
    '006':require('./img/006yhkgl.jpg'),
    '009':require('./img/009yhkgl.jpg'),
    '011':require('./img/011yhkgl.jpg'),
    '014':require('./img/014yhkgl.jpg'),
    '015':require('./img/015yhkgl.jpg'),
    '016':require('./img/016yhkgl.jpg'),
    '018':require('./img/018yhkgl.jpg'),
    '021':require('./img/021yhkgl.jpg'),
    '022':require('./img/022yhkgl.jpg'),
  }
  
}


//协议字典

export const protocolCode = {
    '华夏财富同步信息快捷开户协议书': 'pro_001',
    '华夏财富电子交易服务协议': 'pro_002',
    '投资人权益须知': 'pro_003',
    '电子签名约定书': 'pro_004',
    '上海华夏财富投资管理有限公司快易付业务协议': 'pro_005',
    '关于我们':'pro_006',
    '定期定额申请协议':'pro_007',
    '上海华夏财富投资管理有限公司基金投资顾问服务协议':'pro_008',
    '华夏查理智投投资者风险告知函':'pro_009',
    '养老计算器规则':'pro_010',
    '教育计算器规则':'pro_011',
    '转出方式及额度说明':'pro_012',
    '投资者风险告知函':'pro_013',
    '华夏查理智投定期定额申请协议':'pro_014',
    '投资组合策略说明书-货币':'pro_021',
    '投资组合策略说明书-固收':'pro_022',
    '投资组合策略说明书-权益':'pro_023',
    '投资组合策略说明书-指数':'pro_024',
    '投资组合策略说明书-教育':'pro_025',
    '投资组合策略说明书-养老':'pro_026',
    '华夏财富用户隐私政策':'pro_027',
    '小常乐目标盈008期组合策略说明书':'pro_029',
    '小常乐目标盈009期组合策略说明书':'pro_030',
    '小常乐目标盈010期组合策略说明书':'pro_031',
    '小常乐目标盈011期组合策略说明书':'pro_032',
    '工资宝绝对收益组合策略说明书':'pro_041',
    '7分小进取组合策略说明书':'pro_044',
    '投资组合策略说明书-指数增强':'pro_047',
    '投资组合策略说明书-安心宝':'pro_057',
    '投资组合策略说明书-价值精选':'pro_059',
    '投资组合策略说明书-货币增强':'pro_060',


}

//常见问题
export const FAQCode = {
    'wt_yhk': 'wt_yhk',

}




// WEBPACK FOOTER //
// ./src/BankCode.js